export const psychApps = [
    {
        item: "ADHD-Current",
        type: "survey",
        title: "ADHD, Current Symptoms (ASRSv1.1)",
        subtitle: "Evaluate current attentional and hyperactive symptoms.",
    },
    {
        item: "ADHD-Childhood",
        type: "survey",
        title: "ADHD, Childhood Symptoms",
        subtitle: "As an adult, reflect on childhood attentional and hyperactive symptoms (<12yo)",
    },
    {
        item: "ADHD-Parents",
        type: "survey",
        title: "ADHD, Parent Report",
        subtitle: "Gather information from parents or someone who knew you well when you were <12yo",
    },
    {
        item: "HAMD",
        type: "survey",
        title: "Depression (HAM-D)",
        subtitle: "Evaluate current depressive symptoms",
    },
    {
        item: "OCD-YBOCS",
        type: "survey",
        title: "OCD Symptoms (YBOCS)",
        subtitle: "Evaluate obsessive and compulsive symptoms",
    },
    {
        item: "ISI",
        type: "survey",
        title: "Sleep, Insomnia Severity Index (ISI)",
        subtitle: "Evaluate your insomnia symptoms and severity",
    },
    {
        item: "Bipolar-Tracker",
        type: "log",
        title: "Bipolar Mood Tracker",
        subtitle: "Track your mood swings with this log, including depression and mania.",
    },
    {
        item: "Sleep-Log",
        type: "log",
        title: "Sleep Log - Track Your Sleep",
        subtitle: "Track the quality and efficiency of your sleep over time",
    },
];

export const providerApps = [
    {
        item: "Trans-Letter",
        type: "survey",
        title: "Gender Confirming Surgery Letter",
        subtitle: "Template for writing mental health letters in support of gender confirming surgeries.",
    },
    {
        item: "Med-Billing",
        type: "outside",
        title: "Med-Billing Calculator App",
        subtitle: "E&M CPT billing calculator for outpatient, established patients based on 2021 AMA updates. (iOS App).",
    },
];

